import { useEffect } from 'react';
import styles from './SignupConsultPopup.module.scss';
import useSignupConsult from '@/hooks/useSignupConsult';
import { usePrivacyConsentPopup } from '@/hooks/usePrivacyConsentPopup';

interface SignupConsultPopupProps {
	onClose: () => void;
}

const SignupConsultPopup = ({ onClose }: SignupConsultPopupProps) => {
	const { formData, isSubmitEnabled, inquiryPsClickSubmit, handleInputChange } = useSignupConsult();
	const { openPrivacyConsentPopup } = usePrivacyConsentPopup();

	useEffect(() => {
		const html = document.documentElement;
		const body = document.body;
		html.style.overflow = 'hidden';
		body.style.overflow = 'hidden';

		return () => {
			html.style.overflow = '';
			body.style.overflow = '';
		};
	}, []);

	const handleSubmit = () => {
		inquiryPsClickSubmit().then(() => onClose());
	};

	return (
		<div className={styles.overlay}>
			<div className={styles['popup-wrap']} onClick={e => e.stopPropagation()}>
				<button type="button" className={styles['popup-wrap__close']} onClick={onClose}></button>
				<div className={styles.popup}>
					<div className={styles['popup__title']}>
						<p>전문 상담팀이 직접 연락드립니다.</p>
						<p className={styles['popup__title__sub']}>영업시간 내 순차적으로 빠르게 연락드리겠습니다.</p>
					</div>
					<div className={styles['popup__content']}>
						<div className={`${styles['form-group']} form-group`}>
							<div className={`${styles['form-box']} form-box`}>
								<label htmlFor="consultCompanyName" className={`${styles['require']}`}>
									회사명
								</label>
								<input
									id="consultCompanyName"
									type="text"
									name="consultCompanyName"
									placeholder="회사명을 입력하세요."
									value={formData.consultCompanyName}
									onChange={handleInputChange}
								/>
							</div>
							<div className={`${styles['form-box']} form-box`}>
								<label htmlFor="consultUserName" className={`${styles['require']}`}>
									이름
								</label>
								<input
									id="consultUserName"
									type="text"
									name="consultUserName"
									placeholder="이름을 입력하세요."
									value={formData.consultUserName}
									onChange={handleInputChange}
								/>
							</div>
							<div className={`${styles['form-box']} form-box`}>
								<label htmlFor="consultUserNumber" className={`${styles['require']}`}>
									연락처
								</label>
								<input
									id="consultUserNumber"
									type="text"
									name="consultUserNumber"
									placeholder="연락처를 입력하세요."
									maxLength={11}
									value={formData.consultUserNumber}
									onChange={handleInputChange}
								/>
							</div>
							<div className={`${styles['form-box']} form-box`}>
								<label htmlFor="consultUserMail" className={`${styles['require']}`}>
									이메일
								</label>
								<input
									id="consultUserMail"
									type="email"
									name="consultUserMail"
									placeholder="이메일을 입력하세요."
									value={formData.consultUserMail}
									onChange={handleInputChange}
								/>
							</div>
							<div className={`${styles['form-box']} form-box`}>
								<label htmlFor="consultUserInquiry">문의사항</label>
								<textarea
									id="consultUserInquiry"
									name="consultUserInquiry"
									placeholder="문의 내용을 간략하게 적어주세요."
									value={formData.consultUserInquiry}
									onChange={handleInputChange}></textarea>
							</div>

							<div className={styles['terms-box']}>
								<p className={styles['terms-box__text']}>운영시간 : 월~금 : 09:00~18:00 / 토,일, 공휴일 휴무</p>
								<div className={styles['chk-box']}>
									<input
										type="checkbox"
										name=""
										id="consultInquiryAgree"
										checked={formData.consultInquiryAgree}
										onChange={handleInputChange}
									/>
									<label onClick={openPrivacyConsentPopup}>개인정보 수집 및 이용동의 (필수)</label>
								</div>
							</div>

							<div className="button-group align-center">
								<button
									id="consultInquiryPsBtn"
									className={`${styles['submit-btn']} btn black`}
									onClick={handleSubmit}
									disabled={!isSubmitEnabled}>
									상담 신청
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SignupConsultPopup;
